// app/javascript/controllers/switch_accessible_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "announcement"]

  connect() {
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.addEventListener("keydown", this.handleKeyDown)
    }
  }

  disconnect() {
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.removeEventListener("keydown", this.handleKeyDown)
    }
  }

  announce() {
    if (this.hasAnnouncementTarget && this.hasCheckboxTarget) {
      this.announcementTarget.textContent = this.checkboxTarget.checked ? "on" : "off"
    }
  }

  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      this.checkboxTarget.checked = !this.checkboxTarget.checked
      this.checkboxTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}